<template>
  <div
    :class="[
      'inline-edit',
      { highlight: showHighlight() },
      { mt02: inline },
      { mt2: !inline }
    ]"
  >
    <i
      v-if="canEdit && !edit"
      class="fa fa-pencil has-text-light pull-right pointer"
      @click="toggleEdit"
    ></i>
    <i
      v-if="edit && !loading"
      class="fa fa-times pull-right pointer has-text-light"
      @click="toggleEdit"
    ></i>
    <i
      v-if="edit && !loading"
      :class="[
        'fa fa-floppy-o pull-right pointer',
        { 'has-text-primary': !inverse }
      ]"
      @click="onSave"
    ></i>
    <i v-if="edit && loading" class="fa fa-refresh fa-spin pull-right"></i>

    <h3 :class="[{ 'is-inline-block': inline }]">{{ title }}</h3>

    <div
      v-if="!edit && field !== 'birthday'"
      :class="['value', { 'is-inline-block': inline }]"
    >
      <nl2br v-if="value" tag="p" :text="value" />
    </div>

    <div
      v-if="!edit && field === 'birthday'"
      :class="['value', { 'is-inline-block': inline }]"
    >
      {{ formatDate(value) }}
    </div>

    <div v-if="edit && fieldType('textarea')" class="inline-edit">
      <textarea class="textarea" v-model="editValue"></textarea>
    </div>

    <div v-if="edit && fieldType('text')" class="inline-edit">
      <input class="input" type="text" v-model="editValue" />
    </div>

    <div v-if="edit && fieldType('date')" class="inline-edit">
      <flat-pickr
        v-model="editValue"
        :config="config"
        input-class="input"
      ></flat-pickr>
    </div>

    <div v-if="edit && fieldType('insurance')" class="inline-edit select">
      <select v-model="editValue" class="select">
        <option v-for="insurance in this.insurance" :value="insurance">{{
          insurance
        }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import nl2br from "vue-nl2br";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import EncountersService from "@/services/EncountersService";
import "../../../node_modules/flatpickr/dist/flatpickr.css";

export default {
  name: "inline-edit",

  props: [
    "title",
    "field",
    "value",
    "onSubmit",
    "canEdit",
    "highlightField",
    "inverse",
    "inline"
  ],

  components: {
    nl2br,
    flatPickr
  },

  data() {
    return {
      edit: false,
      editValue: this.value,
      loading: false,
      highlight: false,
      insurance: [],
      config: {
        altInput: true,
        altFormat: "m.d.Y"
      }
    };
  },

  computed: {
    isUser() {
      return this.$store.getters.isUser;
    }
  },

  methods: {
    fieldType(type) {
      let kind = false;
      if (type === "insurance" && this.field === "insurance") {
        kind = true;
      } else if (type === "text" && this.field === "preferredName") {
        kind = true;
      } else if (type === "date" && this.field === "birthday") {
        kind = true;
      } else if (
        type === "textarea" &&
        !["insurance", "preferredName", "birthday"].includes(this.field)
      ) {
        kind = true;
      }

      return kind;
    },
    toggleEdit() {
      this.edit = !this.edit;
      if (!this.edit) {
        this.editValue = this.value;
      }
    },
    onSave() {
      this.loading = true;
      this.onSubmit(this.field, this.editValue).then(() => {
        this.loading = false;
        this.edit = false;
      });
    },
    showHighlight() {
      return this.field === this.highlightField;
    },
    formatDate(date) {
      return moment(date).format("MM.DD.YYYY");
    }
  },

  mounted() {
    if (this.field === "insurance" && !this.isUser) {
      EncountersService.getInsurance().then(response => {
        this.insurance = response;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.inline-edit {
  .fa {
    font-size: 98%;
    margin-right: 0.5rem;
  }
  &.highlight {
    background: #53f4ff;
    border-radius: 5px;
  }
}
p {
  font-size: 1rem;
}
</style>
